import { isRawBackedAuditField } from "./audit-field-token-and-kind.js";

export function hasReadableAuditValue(value) {
  if (value === null || value === undefined) return false;
  const trimmed = String(value).trim();
  return trimmed !== "" && trimmed !== "-";
}

export function resolveUpdateAuditValueSource(audit, side) {
  const displayValue = side === "from" ? audit?.from : audit?.to;
  const rawValue = side === "from" ? audit?.fromRaw : audit?.toRaw;

  if (isRawBackedAuditField(audit?.field)) {
    if (hasReadableAuditValue(displayValue)) return displayValue;
    if (hasReadableAuditValue(rawValue)) return rawValue;
    return displayValue;
  }

  return displayValue;
}
